import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { Resolucion } from '../../models/t3_resolucion.model';
import { TipoResolucion } from '../../models/t2_tiporesolucion.model';
import { Facultad } from '../../models/t4_facultades.model';
import { ResolucionesService } from '../../services/resoluciones.service';
import { TiposresolucionesService } from '../../services/tiposresoluciones.service';
import { FacultadesService } from '../../services/facultades.service';
import { environment } from './../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';

import $ from 'jquery';
import { RouterLink } from '@angular/router';
declare var bootstrap: any;

@Component({
  selector: 'app-admin-resoluciones-detalles',
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './admin-resoluciones-detalles.component.html',
  styleUrl: './admin-resoluciones-detalles.component.css'
})
export class AdminResolucionesDetallesComponent {

 public env = environment;

  usuarios: Resolucion[] = [];
  usuario: Resolucion = new Resolucion();
  usuario_find: Resolucion = new Resolucion();
  tiporesolucion: TipoResolucion = new TipoResolucion();
  facultades: Facultad[] = [];
  facultad: Facultad = new Facultad();

  resolucionCargada: Resolucion = new Resolucion();
  resolucionesCargadas: Resolucion[] = [];
  resolucionProcesada: Resolucion = new Resolucion();
  resolucionesProcesadas: Resolucion[] = [];


  // Control de botones y estados
  btn: boolean = true;
  ready: boolean = false;
  searchTerm: string = '';
    
  // Paginación
  pages: any[] = [{}];
  pageActive: number = 1;
  pageSize: number = 20;

  // Resolucion logueado
  login_user: any;
  
  constructor(
    private auth: AuthService,
    private service: ResolucionesService,
    private serviceTipo: TiposresolucionesService,
    private serviceFacultades: FacultadesService,
    private toastr: ToastrService,
    private route: ActivatedRoute
  ){
    this.usuario_find = new Resolucion();
    this.login_user = this.auth.login_user;
  }
  
    ngOnInit(): void {
      this.route.paramMap.subscribe(params => {
        this.tiporesolucion.Id = params.get('id') || '';
        this.usuario.SessionRecordId = params.get('id') || '';
        this.usuario_find.SessionRecordId = params.get('id') || ''; // 'id' debe coincidir con el nombre del parámetro en tu ruta
        this.paginar();
        this.getTipoResolucion();
        this.getFacultades();
      });
    }
  
    paginar(){
      this.ready = false;
      this.usuario_find.Name = this.searchTerm;
      this.service.getPages(this.pageSize, this.usuario_find).subscribe(
        res => {
          //console.log(res);
          if (res.length < this.pageActive) {
            if (this.searchTerm.trim() === "") {
              this.pageActive = res.length;
            } else {
              this.pageActive = 1;
            }
          }
          this.pages = res;
          this.getData(this.pageActive);
        },
        err => {
          console.error(err);
          this.ready = true;
          this.toastr.error('Error al cargar las páginas', 'Error');
        }
      );   
    }
  
    getData(page: number) {
      this.ready = false;
      this.pageActive = page;
      try {
          this.service.getDataFilter(this.pages[page - 1], this.usuario_find).subscribe(
            res => {
              //console.log('Resolucions cargados:', res);
              this.usuarios = res;
              this.ready = true;
            },
            err => {
              console.error(err);
              this.ready = true;
              this.toastr.error('Error al cargar usuarios', 'Error');
            }
          );
      } catch (error) {
          console.error(error);
          this.pageActive -= 1;
          if (this.pageActive > 0) {
            this.service.getDataFilter(this.pages[this.pageActive - 1], this.usuario_find).subscribe(
              res => {
                this.usuarios = res;
                this.ready = true;
              },
              err => {
                console.error(err);
                this.ready = true;
                this.toastr.error('Error al cargar usuarios', 'Error');
              }
            );
          } else {
            this.ready = true;
          }
      }
      

    }

    closeForm(): void {
      const modalElement = document.getElementById('modalAdd');
      if (modalElement) {
        const modal = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
        modal.hide();
      }
      this.usuario = new Resolucion();
      $('#fileInput').val('');
    }

    closeConfirm(): void {
      const modalElement = document.getElementById('modalEliminar');
      if (modalElement) {
        const modal = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
        modal.hide();
      }
      this.usuario = new Resolucion();
    }

    resetForm(): void {
      this.usuario = new Resolucion();
      $('#fileInput').val('');
    }

    edit(usuario: Resolucion): void {
      $('#fileInput').val('');
      this.usuario = {...usuario};
      const date = new Date(this.usuario.Date);
      this.usuario.Date = date.toISOString().split('T')[0];
    }
  
    submit(): void {
      this.btn = false;
      this.usuario.SessionRecordId = this.tiporesolucion.Id || '';
      if (this.usuario.Id==null) {
        // Crear nuevo usuario
        this.service.postData(this.usuario)
          .subscribe(
            (response) => {
              this.btn = true;
              this.toastr.success('Elemento creado exitosamente', 'Éxito');
              this.closeForm();
              this.paginar();
            },
            (error) => {
              this.btn = true;
              console.error('Error al crear elemento', error.error);
              this.toastr.error('Error al crear elemento', error.error);
            }
          );
      } else {
        // Actualizar usuario existente
        this.service.putData(this.usuario)
          .subscribe(
            (response) => {
              this.btn = true;
              this.toastr.success('Elemento actualizado exitosamente', 'Éxito');
              this.closeForm();
              this.paginar();
            },
            (error) => {
              this.btn = true;
              console.error('Error al crear elemento', error.error);
              this.toastr.error('Error al crear elemento', error.error);
            }
          );
      }
    }
  

    eliminar(usuario: any): void {
      if (usuario.Id) {
        this.btn = true;
        this.usuario = {...usuario};
      } else {
        this.btn = false;
        this.service.deleteData(this.usuario)
          .subscribe(
            (response) => {
              this.btn = true;
              this.toastr.success('Elemento eliminado exitosamente', 'Éxito');
              this.paginar();
              this.closeConfirm();
            },
            (error) => {
              console.error('Error al eliminar elemento.', error.error);
              this.btn = true;
              this.toastr.error('Error al eliminar elemento.', error.error);
            }
          );
      }
    }
  

  getTipoResolucion(){
    this.serviceTipo.getDataId(this.tiporesolucion).subscribe(
      res => {
        this.tiporesolucion = res;
        //console.log('Tipo de Resolución cargado:', this.tiporesolucion);
      },
      err => {
        console.error('Error al cargar Tipo de Resolución:', err);
      }
    );
  }

  getFacultades(){
    this.serviceFacultades.getDataFilter(0, this.facultad).subscribe(
      res => {
        this.facultades = res;
        //console.log('Facultades cargadas:', this.facultades);
      },
      err => {
        console.error('Error al cargar Facultades:', err);
      }
    );
  }


  onIsLinkChange(e: any) {
    this.usuario.IsLink = e;
    if(this.usuario.IsLink == 1){
      this.usuario.Url = '';
      this.usuario.File = null;
    }else{
      this.usuario.Url = '';
      this.usuario.File = null;
      $('#fileInput').val('');
    }
  }






  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.usuario.File = file;
    }
  }

  onFilesSelected(event: any) {
    const files: FileList = event.target.files;
    const tmp_files = Array.from(files);
    // Crear una resolución por cada archivo
    for (let i = 0; i < tmp_files.length; i++) {
      const file = tmp_files[i];
      const resolucion = new Resolucion();
      resolucion.File = file;
      resolucion.SessionRecordId = this.tiporesolucion.Id || '';
      // Buscar si ya existe un archivo con el mismo nombre
      const existingIndex = this.resolucionesCargadas.findIndex(r => r.File?.name === file.name);
      if (existingIndex !== -1) {
        // Si existe, reemplazar el archivo existente
        this.resolucionesCargadas[existingIndex] = resolucion;
      } else {
        // Si no existe, agregar nuevo archivo
        this.resolucionesCargadas.push(resolucion);
      }
    }
    event.target.value = null; // Limpiar el input para permitir seleccionar el mismo archivo nuevamente
  }

  clearFileInput(e: number) {
    this.resolucionesCargadas.splice(e, 1);
  }

  clearFilesInput() {
    this.resolucionesCargadas = [];
    $('#pdfFiles').val('');
  }

  clearFileInputProcesar(e: number) {
    this.resolucionesProcesadas.splice(e, 1);
  }

  clearFilesInputProcesar() {
    this.resolucionesProcesadas = [];
  }

  formatFileSize(size: number | undefined): string {
    if (size === undefined || size === null) {
      return 'Tamaño desconocido';
    }

    const units = ['B', 'KB', 'MB', 'GB'];
    let i = 0;
    let formattedSize = size;

    while (formattedSize >= 1024 && i < units.length - 1) {
      formattedSize /= 1024;
      i++;
    }

    return `${formattedSize.toFixed(2)} ${units[i]}`;
  }





  subirArchivos() {
    if (this.resolucionesCargadas.length === 0) {
      this.toastr.warning('No hay archivos para subir.', 'Advertencia');
      return;
    }
    this.btn = false;
    this.resolucionesCargadas.forEach(r => {
      r.LoadEstate = 1; // Marcamos como "Cargando"
    });
    this.service.postSubirData(this.resolucionesCargadas)
    .subscribe(
      (response) => {
        this.toastr.success('Subida de archivos terminada', 'Éxito');
        for (let i = 0; i < this.resolucionesCargadas.length; i++) {
          for (let j = 0; j < response.resoluciones.length; j++) {
            if (this.resolucionesCargadas[i].File?.name == response.resoluciones[j].File.name) {
              this.resolucionesCargadas[i].LoadEstate = response.resoluciones[j].LoadEstate; // Marcamos como "Cargado"
              this.resolucionesCargadas[i].Url = response.resoluciones[j].Url; // Actualizamos la URL
              this.resolucionesCargadas[i].FileName = response.resoluciones[j].File.name; // Actualizamos el nombre del archivo
              console.log("Coincidencia encontrada");
            }
          }
        }
        this.procesarArchivos();
      },
      (error) => {
        this.btn = true;
        console.error('Error al subir archivos', error.error);
        this.toastr.error('Error al subir archivos', error.error);
      }
    );
  }

  async procesarArchivos() {
    
    this.resolucionesProcesadas = [];
    var n_procesos = 0;

    for (let i = 0; i < this.resolucionesCargadas.length; i++) {
      const resolucion = {...this.resolucionesCargadas[i]};
      try {
        // Convertir Observable a Promise para usar async/await
        //const response = await firstValueFrom(this.service.postProcesarArchivos({...resolucion}));

        console.log(resolucion);
        this.service.postProcesarArchivos({...resolucion}).subscribe(
          response => {
            console.log(response);
            this.resolucionesCargadas[i].LoadEstate = 4;
            this.resolucionesProcesadas.push(response.data);
            console.log(`Archivo ${i + 1} procesado:`, response.data);
            n_procesos++;
          },
          err => {
            this.resolucionesCargadas[i].LoadEstate = 3;
            this.resolucionesProcesadas.push(err.error.data);
            console.error(`Error procesando archivo ${i + 1}:`, err);
            n_procesos++;
          }
        );
        
        

      } catch (error) {
        this.resolucionesCargadas[i].LoadEstate = 4;
        n_procesos++;
        resolucion.LoadEstate = 3; // Marcamos como "Error"
        this.resolucionesProcesadas.push(new Resolucion());
        console.error(`Error procesando archivo ${i + 1}:`, error);
        this.toastr.error(`Error procesando ${resolucion.Name}`);
      }
    }

    // Esperar hasta que n_procesos sea igual a la cantidad de archivos cargados
    await new Promise<void>(resolve => {
      const check = () => {
      if (n_procesos === this.resolucionesCargadas.length) {
        resolve();
      } else {
        setTimeout(check, 200);
      }
      };
      check();
    });

    // Mostrar resumen al final
    const procesados = this.resolucionesCargadas.filter(r => r.LoadEstate === 4).length;
    const errores = this.resolucionesCargadas.filter(r => r.LoadEstate === 3).length;
    if (procesados > 0) {
      this.toastr.success(`${procesados} archivos procesados exitosamente`);
    }
    if (errores > 0) {
      this.toastr.warning(`${errores} archivos con errores`);
    }
    this.btn = true;
    
    

  }


  async guardarArchivos() {
    if (this.resolucionesProcesadas.length === 0) {
      this.toastr.warning('No hay archivos para guardar.', 'Advertencia');
      return;
    }

    var n_guardados = 0;
    console.log(this.resolucionesProcesadas);
    for (let i = 0; i < this.resolucionesProcesadas.length; i++) {
      this.resolucionesProcesadas[i].LoadEstate = 2; // Marcamos como "Guardando"
      this.service.postGuardarData(this.resolucionesProcesadas[i]).subscribe(
        (response) => {
          n_guardados++;
          console.log('Elemento creado exitosamente', response);
          this.resolucionesProcesadas[i] = response; // Marcamos como "Guardado"
          this.toastr.success('Elemento creado exitosamente', 'Éxito');
        },
        (error) => {
          n_guardados++;
          console.log('Error al crear elemento', error);
          this.resolucionesProcesadas[i] = error.error.data; // Marcamos como "Error"
          console.error('Error al crear elemento', error.error);
          this.toastr.error('Error al crear elemento', error.error);
        }
      );
    }


    // Esperar hasta que n_procesos sea igual a la cantidad de archivos cargados
    await new Promise<void>(resolve => {
      const check = () => {
      if (n_guardados === this.resolucionesCargadas.length) {
        resolve();
      } else {
        setTimeout(check, 200);
      }
      };
      check();
    });


    this.btn = true;
    this.closeForm();
    this.paginar();




    // Lógica para guardar los archivos procesados
    /*

    


    this.service.postGuardarArchivos(this.resolucionesProcesadas).subscribe(
      response => {
        this.toastr.success('Archivos guardados exitosamente');
        console.log('Archivos guardados:', response);
      },
      error => {
        this.toastr.error('Error al guardar archivos', error);
        console.error('Error al guardar archivos:', error);
      }
    );
    */
  }




  // Funciones auxiliares para filtros en el template
  getProcesadosExitosos(): number {
    return this.resolucionesProcesadas.filter(r => r.LoadEstate === 0).length;
  }

  getProcesadosConError(): number {
    return this.resolucionesProcesadas.filter(r => r.LoadEstate === 2).length;
  }

  getTotalProcesados(): number {
    return this.resolucionesProcesadas.length;
  }

  getProcesandose(): number {
    return this.resolucionesProcesadas.filter(r => r.LoadEstate === 0).length;
  }


}
